// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__xdTHu","title":"Header_title__2gOFe","side":"Header_side__3THbA"};